import Vue from 'vue'
import App from './App.vue'
//import loginPage from './tools/loginPage.vue'
import vuetify from './plugins/vuetify';
import 'vue-material-design-icons/styles.css';
import VueRouter from 'vue-router';
import * as VeeValidate from 'vee-validate';
import store from './store/index.js'

import { router } from './router/router.js'
import Icon from 'vue-awesome/components/Icon'

import DatatableSearchTool from './tools/datatableSearchTool'
import DeletingModal from './tools/deletingModal'
import LoginPage from './tools/loginPage'
import FooterView from './viewComponents/footerView.vue'
import Log from './components/log.vue'


Vue.component('v-icon', Icon)
Vue.component('datatableSearchTool', DatatableSearchTool)
Vue.component('deletingModal', DeletingModal)
Vue.component('loginPage', LoginPage)
Vue.component('footerView', FooterView)
Vue.component('log', Log)

Vue.use(VueRouter)

router.beforeEach((to, from, next) => {
  let loggedIn = store.state.loggedAdmin.isLoggedIn
  let isSuperAdmin = store.state.loggedAdmin.isSuperAdmin
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      next({
        path: '/adminlogin',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      if (to.meta.requiresSuperAdmin == true) {
        return isSuperAdmin == true ? next() : next({ path: '/' });
      } else next()
    }
  } else {
    next();
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  VeeValidate,
  store,
  render: h => h(App),
}).$mount('#App')